module.exports = __webpack_public_path__ + "media/game-cinematic.f7d703a6.mp4";